import { WelcomeScreens } from './types';

export const CALENDAR_SCREEN: WelcomeScreens = 'calendar';
export const MEET_SCREEN: WelcomeScreens = 'meet';
export const TASKS_SCREEN: WelcomeScreens = 'tasks';
export const INTEGRATIONS_SCREEN: WelcomeScreens = 'integrations';
export const VIDEO_SCREEN: WelcomeScreens = 'video';

export const TOTAL_NUM_WELCOME_SCREENS = 5;
